import { useQuery } from "@tanstack/react-query";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { WidgetRenderer } from "./Sidebar";

export default function WidgetZone({ position }) {
  const { user } = useAuth();
  const { data: widgetsData } = useQuery({
    queryKey: ["widgets"],
    queryFn: async () => (await api.get("/idg/widgets/public")).data,
    staleTime: 120000,
  });

  if (!widgetsData) return null;

  const visible = widgetsData.filter((w) => {
    if (!w.enabled) return false;
    if (w.position !== position) return false;
    const v = w.settings?.visibility || "all";
    if (v === "guest") return !user;
    if (v === "user") return !!user;
    if (v === "vip") return user?.is_vip;
    if (v === "admin") return user?.role === "admin" || user?.role === "root";
    return true;
  }).sort((a, b) => (a.order || 0) - (b.order || 0));

  if (visible.length === 0) return null;

  return (
    <div className={`widget-zone-${position} space-y-6 mb-6`} data-testid={`widget-zone-${position}`}>
      {visible.map((w) => <WidgetRenderer key={w.id} widget={w} user={user} />)}
    </div>
  );
}
